module.exports = __webpack_public_path__ + "img/payment04.53f994a5.png";